import * as React from "react";
import { StaticImageData } from "next/image";

import { LinkButton } from "@stadium/shared/src/components/shared/button";
import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import { HERO_DEFAULTS, H_05 } from "@stadium/shared/src/helpers/plasmic/static-slices";

import styles from "./main.module.scss";

export interface BulletPoint {
  iconImage?: string;
  iconImgAlt?: string;
  text: string;
}

export interface H05Props {
  // Hero Content
  heading?: string;
  description?: string;
  bulletPoints?: BulletPoint[];

  // CTA Buttons
  primaryButtonText?: string;
  primaryButtonUrl?: string;
  secondaryButtonText?: string;
  secondaryButtonUrl?: string;

  // Hero Image
  heroImage: string | StaticImageData;
  heroImageAlt?: string;

  className?: string;
}

const H05: React.FC<Readonly<H05Props>> = ({
  heading = HERO_DEFAULTS[H_05].heading,
  description = HERO_DEFAULTS[H_05].description,
  primaryButtonText = HERO_DEFAULTS[H_05].primaryButtonText,
  primaryButtonUrl = HERO_DEFAULTS[H_05].primaryButtonUrl,
  secondaryButtonText = HERO_DEFAULTS[H_05].secondaryButtonText,
  secondaryButtonUrl = HERO_DEFAULTS[H_05].secondaryButtonUrl,
  bulletPoints = HERO_DEFAULTS[H_05].bulletPoints,
  heroImage = HERO_DEFAULTS[H_05].heroImage,
  heroImageAlt = HERO_DEFAULTS[H_05].heroImageAlt,
  className,
}) => {
  return (
    <section className={`${styles.sectionWrapper} ${className || ""}`}>
      {/* Main Hero Section */}
      <div className={styles.h05Container}>
        <div className={styles.heroContent}>
          {/* Left Content */}
          <div className={styles.leftContent}>
            {/* Text Content */}
            <div className={styles.textContent}>
              <h1 className={styles.heading}>{heading}</h1>
              <p className={styles.description}>{description}</p>
            </div>

            {bulletPoints.length > 0 && (
              <ul className={styles.bulletList}>
                {bulletPoints.map((bullet) => (
                  <li
                    key={`${bullet.text}-${bullet.iconImage || ""}`}
                    className={styles.bulletItem}
                  >
                    {bullet.iconImage && (
                      <Multimedia
                        type="image"
                        src={bullet.iconImage}
                        alt={bullet.iconImgAlt || ""}
                        className={styles.bulletIcon}
                      />
                    )}
                    <span className={styles.bulletText}>{bullet.text}</span>
                  </li>
                ))}
              </ul>
            )}

            {/* CTA Buttons */}
            <div className={styles.buttonWrapper}>
              {primaryButtonText && primaryButtonUrl && (
                <LinkButton
                  styleType="no-style"
                  href={primaryButtonUrl}
                  className={styles.primaryBtn}
                >
                  {primaryButtonText}
                </LinkButton>
              )}
              {secondaryButtonText && secondaryButtonUrl && (
                <LinkButton
                  styleType="no-style"
                  href={secondaryButtonUrl}
                  className={styles.primaryOutlineBtn}
                >
                  {secondaryButtonText}
                </LinkButton>
              )}
            </div>
          </div>

          {/* Right Image */}
          <div className={styles.rightImage}>
            <Multimedia
              type="image"
              src={heroImage}
              alt={heroImageAlt}
              className={styles.h07Image}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default H05;
